// extracted by mini-css-extract-plugin
export default {"external":"abKM7","deprecatedBorderRadius":"bbKM7","hasAnimation":"cbKM7","container":"dbKM7"};